import template from './template.html.twig';

Shopware.Component.override('sw-extension-card-base', {
    template,

    computed: {
        isPluginNetiNextIncompleteOrderReminder() {
            return this.extension?.name === 'NetiNextIncompleteOrderReminder';
        }
    }
});